export const HA_IDA_CAS_HEADER_LOGIN_TEST = 'HA_IDA_CAS_HEADER_LOGIN_TEST';
export const HA_IDA_V3_LOGIN_TEST = 'HA_IDA_V3_LOGIN_TEST';
